// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file v1/customer_telegram.proto (package tickettally.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file v1/customer_telegram.proto.
 */
export const file_v1_customer_telegram: GenFile = /*@__PURE__*/
  fileDesc("Chp2MS9jdXN0b21lcl90ZWxlZ3JhbS5wcm90bxIOdGlja2V0dGFsbHkudjEiNwogR2VuZXJhdGVDdXN0b21lckxpbmtUb2tlblJlcXVlc3QSEwoLY3VzdG9tZXJfaWQYASABKAUicwohR2VuZXJhdGVDdXN0b21lckxpbmtUb2tlblJlc3BvbnNlEg8KB2NvbW1hbmQYASABKAkSDQoFdG9rZW4YAiABKAkSLgoKZXhwaXJlc19hdBgDIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXAiNwogR2V0Q3VzdG9tZXJUZWxlZ3JhbVN0YXR1c1JlcXVlc3QSEwoLY3VzdG9tZXJfaWQYASABKAUinQEKIUdldEN1c3RvbWVyVGVsZWdyYW1TdGF0dXNSZXNwb25zZRIRCglpc19saW5rZWQYASABKAgSHAoUdGVsZWdyYW1fZ3JvdXBfdGl0bGUYAiABKAkSGAoQdGVsZWdyYW1fY2hhdF9pZBgDIAEoAxItCglsaW5rZWRfYXQYBCABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wIjMKHFVubGlua0N1c3RvbWVyQWNjb3VudFJlcXVlc3QSEwoLY3VzdG9tZXJfaWQYASABKAUiQQodVW5saW5rQ3VzdG9tZXJBY2NvdW50UmVzcG9uc2USDwoHc3VjY2VzcxgBIAEoCBIPCgdtZXNzYWdlGAIgASgJMpUDChdDdXN0b21lclRlbGVncmFtU2VydmljZRKAAQoZR2VuZXJhdGVDdXN0b21lckxpbmtUb2tlbhIwLnRpY2tldHRhbGx5LnYxLkdlbmVyYXRlQ3VzdG9tZXJMaW5rVG9rZW5SZXF1ZXN0GjEudGlja2V0dGFsbHkudjEuR2VuZXJhdGVDdXN0b21lckxpbmtUb2tlblJlc3BvbnNlEoABChlHZXRDdXN0b21lclRlbGVncmFtU3RhdHVzEjAudGlja2V0dGFsbHkudjEuR2V0Q3VzdG9tZXJUZWxlZ3JhbVN0YXR1c1JlcXVlc3QaMS50aWNrZXR0YWxseS52MS5HZXRDdXN0b21lclRlbGVncmFtU3RhdHVzUmVzcG9uc2USdAoVVW5saW5rQ3VzdG9tZXJBY2NvdW50EiwudGlja2V0dGFsbHkudjEuVW5saW5rQ3VzdG9tZXJBY2NvdW50UmVxdWVzdBotLnRpY2tldHRhbGx5LnYxLlVubGlua0N1c3RvbWVyQWNjb3VudFJlc3BvbnNlQihaJmdpdGh1Yi5jb20vZHVjYnQvdHQtZ28vZ2VuL3Byb3RvL3YxO3YxYgZwcm90bzM", [file_google_protobuf_timestamp]);

/**
 * @generated from message tickettally.v1.GenerateCustomerLinkTokenRequest
 */
export type GenerateCustomerLinkTokenRequest = Message<"tickettally.v1.GenerateCustomerLinkTokenRequest"> & {
  /**
   * @generated from field: int32 customer_id = 1;
   */
  customerId: number;
};

/**
 * Describes the message tickettally.v1.GenerateCustomerLinkTokenRequest.
 * Use `create(GenerateCustomerLinkTokenRequestSchema)` to create a new message.
 */
export const GenerateCustomerLinkTokenRequestSchema: GenMessage<GenerateCustomerLinkTokenRequest> = /*@__PURE__*/
  messageDesc(file_v1_customer_telegram, 0);

/**
 * @generated from message tickettally.v1.GenerateCustomerLinkTokenResponse
 */
export type GenerateCustomerLinkTokenResponse = Message<"tickettally.v1.GenerateCustomerLinkTokenResponse"> & {
  /**
   * e.g., "/link_customer abc123xyz"
   *
   * @generated from field: string command = 1;
   */
  command: string;

  /**
   * @generated from field: string token = 2;
   */
  token: string;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 3;
   */
  expiresAt?: Timestamp;
};

/**
 * Describes the message tickettally.v1.GenerateCustomerLinkTokenResponse.
 * Use `create(GenerateCustomerLinkTokenResponseSchema)` to create a new message.
 */
export const GenerateCustomerLinkTokenResponseSchema: GenMessage<GenerateCustomerLinkTokenResponse> = /*@__PURE__*/
  messageDesc(file_v1_customer_telegram, 1);

/**
 * @generated from message tickettally.v1.GetCustomerTelegramStatusRequest
 */
export type GetCustomerTelegramStatusRequest = Message<"tickettally.v1.GetCustomerTelegramStatusRequest"> & {
  /**
   * @generated from field: int32 customer_id = 1;
   */
  customerId: number;
};

/**
 * Describes the message tickettally.v1.GetCustomerTelegramStatusRequest.
 * Use `create(GetCustomerTelegramStatusRequestSchema)` to create a new message.
 */
export const GetCustomerTelegramStatusRequestSchema: GenMessage<GetCustomerTelegramStatusRequest> = /*@__PURE__*/
  messageDesc(file_v1_customer_telegram, 2);

/**
 * @generated from message tickettally.v1.GetCustomerTelegramStatusResponse
 */
export type GetCustomerTelegramStatusResponse = Message<"tickettally.v1.GetCustomerTelegramStatusResponse"> & {
  /**
   * @generated from field: bool is_linked = 1;
   */
  isLinked: boolean;

  /**
   * @generated from field: string telegram_group_title = 2;
   */
  telegramGroupTitle: string;

  /**
   * @generated from field: int64 telegram_chat_id = 3;
   */
  telegramChatId: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp linked_at = 4;
   */
  linkedAt?: Timestamp;
};

/**
 * Describes the message tickettally.v1.GetCustomerTelegramStatusResponse.
 * Use `create(GetCustomerTelegramStatusResponseSchema)` to create a new message.
 */
export const GetCustomerTelegramStatusResponseSchema: GenMessage<GetCustomerTelegramStatusResponse> = /*@__PURE__*/
  messageDesc(file_v1_customer_telegram, 3);

/**
 * @generated from message tickettally.v1.UnlinkCustomerAccountRequest
 */
export type UnlinkCustomerAccountRequest = Message<"tickettally.v1.UnlinkCustomerAccountRequest"> & {
  /**
   * @generated from field: int32 customer_id = 1;
   */
  customerId: number;
};

/**
 * Describes the message tickettally.v1.UnlinkCustomerAccountRequest.
 * Use `create(UnlinkCustomerAccountRequestSchema)` to create a new message.
 */
export const UnlinkCustomerAccountRequestSchema: GenMessage<UnlinkCustomerAccountRequest> = /*@__PURE__*/
  messageDesc(file_v1_customer_telegram, 4);

/**
 * @generated from message tickettally.v1.UnlinkCustomerAccountResponse
 */
export type UnlinkCustomerAccountResponse = Message<"tickettally.v1.UnlinkCustomerAccountResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message tickettally.v1.UnlinkCustomerAccountResponse.
 * Use `create(UnlinkCustomerAccountResponseSchema)` to create a new message.
 */
export const UnlinkCustomerAccountResponseSchema: GenMessage<UnlinkCustomerAccountResponse> = /*@__PURE__*/
  messageDesc(file_v1_customer_telegram, 5);

/**
 * @generated from service tickettally.v1.CustomerTelegramService
 */
export const CustomerTelegramService: GenService<{
  /**
   * Generate link token for customer (returns /link_customer command)
   *
   * @generated from rpc tickettally.v1.CustomerTelegramService.GenerateCustomerLinkToken
   */
  generateCustomerLinkToken: {
    methodKind: "unary";
    input: typeof GenerateCustomerLinkTokenRequestSchema;
    output: typeof GenerateCustomerLinkTokenResponseSchema;
  },
  /**
   * Get customer's Telegram link status
   *
   * @generated from rpc tickettally.v1.CustomerTelegramService.GetCustomerTelegramStatus
   */
  getCustomerTelegramStatus: {
    methodKind: "unary";
    input: typeof GetCustomerTelegramStatusRequestSchema;
    output: typeof GetCustomerTelegramStatusResponseSchema;
  },
  /**
   * Unlink customer's Telegram account
   *
   * @generated from rpc tickettally.v1.CustomerTelegramService.UnlinkCustomerAccount
   */
  unlinkCustomerAccount: {
    methodKind: "unary";
    input: typeof UnlinkCustomerAccountRequestSchema;
    output: typeof UnlinkCustomerAccountResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_v1_customer_telegram, 0);

